import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useUserHierarchyReducer = () =>
  useSelector((state: ApplicationState) => state.userHierarchy);
